import GeneralContainer from "../../../../Components/General/Widgets/General/GeneralContainer";

const General = () => {
  return <GeneralContainer />;
};

export default General;
